import {register} from './../exports/theme-sections';
import {popupVideo} from './../exports/popups';
import {galleryZoom} from './../exports/modals';

const selectors = {
  padding: 'data-padding',
  active: 'isActive',
  disabled: 'gallery--disabled',
  section: '[data-section-type]',
  enabled: '[data-gallery-enabled]',
};

class Lookbook {
  constructor(el) {
    this.section = el;

    this.outer = this.section.parentNode;
    this.inner = this.section.querySelector(selectors.enabled);
    if (this.inner) {
      // section is enabled
      this.outer.classList.add(selectors.active);
    }
    this.findNext(this.outer);
  }
  findNext(startingPoint) {
    const outer = startingPoint.nextElementSibling;
    if (outer === null) {
      // last section on page
      return;
    }
    const inner = outer.querySelector(selectors.enabled);
    if (inner === null) {
      // next section is diabled keep going
      outer.classList.add(selectors.disabled);
      this.findNext(outer);
    } else {
      // Found a neighbor
      this.nextOuter = outer;
      this.subtractPadding();
    }
  }
  subtractPadding() {
    this.padded = (this.section.getAttribute(selectors.padding) !== 'false');
    this.nextPadded = (this.nextOuter.querySelector(selectors.section).getAttribute(selectors.padding) !== 'false');
    if (this.padded && this.nextPadded) {
      const paddedSection = this.nextOuter.querySelector(selectors.enabled);
      if (paddedSection) {
        paddedSection.style.setProperty('padding-top', '0px');
      }
    }
  }
}

const lookbookSection = {
  onLoad() {
    new Lookbook(this.container);
  },
};

const gallerySection = {
  onLoad() {
    popupVideo(this.container);
    galleryZoom(this.container);
  },
};

register('gallery', [lookbookSection, gallerySection]);
register('gallery-text', lookbookSection);
